import * as React from 'react';
import { Paper, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

const ContentArea = styled(Paper)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(2),
  },
  [theme.breakpoints.up('md')]: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(5),
  },
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  maxWidth: 1200,
  width: '92%',
}));

export default function ContentWrapper({ children }) {
  return (
    <Grid
      container
      direction='row'
      justifyContent='center'
      alignItems='stretch'
    >
      <ContentArea elevation={0} square>
        {children}
      </ContentArea>
    </Grid>
  );
}
